// src/pages/CursosPorPolo.js

import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import CursosTable from '../components/CursosTable';


const CursosPorPolo = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-cursos'>
                <CursosTable/>
            </div>
        </>
    );
};

export default CursosPorPolo;
